import { render, staticRenderFns } from "./TotalTransaksi.vue?vue&type=template&id=95269a8c"
import script from "./TotalTransaksi.vue?vue&type=script&lang=js"
export * from "./TotalTransaksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports